import React from 'react';

import { EntryFeature } from '../ui/split-feature/EntryFeature';
import type { Product } from '../../content/types/product';
import { getProductPath } from '../../content';

type ProductListProps = {
  products: Product[];
};

export const ProductList: React.FC<ProductListProps> = ({ products }) => {
  return (
    <div>
      {products.map((product, index) => (
        <EntryFeature
          key={product.id}
          entry={product}
          placement={index % 2 === 0 ? 'Right' : 'Left'}
          detailPath={getProductPath(product.slug)}
        />
      ))}
    </div>
  );
};
